export enum ServiceFrequency {
    Weekly = 'Weekly',
    FortWeekly = 'Fort Nightly',
    Monthly = 'Monthly',
    QuarterYearly = 'Quarterly',
    HalfYearly = 'Half yearly',
    Yearly = 'Yearly',
    Weekend = 'Weekend',
    Daily = 'Daily'
  }